import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <div
      class="tw-flex tw-flex-col tw-items-center tw-justify-center"
      role="contentinfo"
    >
      <app-footerlinks class="tw-w-full" [isLogout]="false"></app-footerlinks>
      <app-buildinfo></app-buildinfo>
    </div>
  `,
  styles: [``],
})
export class FooterComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
